var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-template page-wrapper"},[_c('OrganismPageLoader'),_vm._v(" "),_c('OrganismsOrganismMenuBarEmbedProject'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('LazyOrganismsOrganismModals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }